import * as tslib_1 from "tslib";
import { getReadHostItemIndex, lazyLaunchTranslateCommand } from 'owa-addins-core';
import { MailRowDataPropertyGetter } from 'owa-mail-list-store';
import getLatestNonDraftItemIdFromConversation from 'owa-mail-message-actions/lib/utils/getLatestNonDraftItemIdFromConversation';
import { trace } from 'owa-trace';
import { action } from 'satcheljs/lib/legacy';
/**
 * Translate the given row
 * @param rowKeys the row keys
 * @param tableView the table view
 * @param actionSource the action source that triggers the block action
 */
export default action('translateFromTable')(function translateFromTable(rowKeys, tableView, actionSource) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var selectedRowId, _a, latestNonDraftItemId;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    selectedRowId = MailRowDataPropertyGetter.getRowClientItemId(rowKeys[0], tableView);
                    if (!rowKeys || rowKeys.length == 0) {
                        trace.error('Translate button should not show when empty list');
                        return [2 /*return*/];
                    }
                    _a = tableView.tableQuery.listViewType;
                    switch (_a) {
                        case 0 /* Conversation */: return [3 /*break*/, 1];
                        case 1 /* Message */: return [3 /*break*/, 5];
                    }
                    return [3 /*break*/, 7];
                case 1: return [4 /*yield*/, getLatestNonDraftItemIdFromConversation(selectedRowId)];
                case 2:
                    latestNonDraftItemId = _b.sent();
                    if (!(latestNonDraftItemId && latestNonDraftItemId.Id)) return [3 /*break*/, 4];
                    return [4 /*yield*/, lazyLaunchTranslateCommand.import()];
                case 3:
                    (_b.sent())(getReadHostItemIndex(latestNonDraftItemId.Id));
                    _b.label = 4;
                case 4: return [3 /*break*/, 7];
                case 5: return [4 /*yield*/, lazyLaunchTranslateCommand.import()];
                case 6:
                    (_b.sent())(getReadHostItemIndex(selectedRowId.Id));
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=translate.js.map